import type { SVGProps } from 'react';
import * as React from 'react';

const SvgCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" {...props}>
    <path
      d="M12.242 13.611a6.97 6.97 0 0 1-.348-.01c-.51.01-1.272-.009-2.092-.019-1.659-.021-3.54-.046-4.386.001-3.23.17-4.893-1.603-5.104-3.443-.198-1.72.863-3.684 3.262-4.248.533-1.748 1.753-2.933 3.463-3.35 1.963-.478 4.23.197 5.513 1.646.909 1.026 1.22 2.29.901 3.609a2.902 2.902 0 0 1 1.925 1.492c.487.938.445 2.054-.11 2.91-.35.541-1.198 1.411-3.023 1.412Zm-5.287-1.343c.874 0 1.904.013 2.862.025.813.01 1.568.02 2.113.02 1.085.065 1.873-.228 2.252-.814.304-.468.322-1.087.047-1.616-.278-.536-.805-.857-1.447-.881a.804.804 0 0 1-.718-1.084c.509-1.352.019-2.31-.482-2.876-.964-1.088-2.748-1.612-4.243-1.248-.933.228-2.141.883-2.602 2.714a.796.796 0 0 1-.632.588c-1.918.339-2.648 1.739-2.516 2.896.132 1.149 1.192 2.44 3.754 2.303.382-.021.951-.028 1.609-.028Zm6.318-3.898v.002z"
      fill="currentColor"
    />
  </svg>
);
export default SvgCloud;
